import { TooltipComponentOption } from "echarts";
import { round } from "lodash";

import { ABBREVIATED_OPTION } from "@/hooks/useConfig";
import { FormatCurrency } from "@/hooks/useConfig/currency";

import { MetricView } from "../components/RevenueBreakdown";

export const getRevenueBreakdownTooltip = (
  formatCurrency: FormatCurrency,
  selectedView: string | null
): TooltipComponentOption => ({
  trigger: "axis",
  formatter: (params: any) => {
    if (selectedView === MetricView.ROI) {
      const roiParam = params[0];
      if (!roiParam) return "";

      const roiValue = roiParam.value;
      const displayValue = roiValue != null ? `${round(roiValue)}%` : "N/A";

      return `
        <div style='padding: 16px; border-radius: 4px'>
          <div style='display: flex; flex-direction: column; gap: 0.5rem;'>
            <div style='font-weight: 600;'>${roiParam.name}</div>
            <div style='display: flex; align-items: center; gap: 0.5rem;'>
              <div style='width: 12px; height: 12px; background-color: ${roiParam.color}; border-radius: 2px;'></div>
              <div>${roiParam.seriesName} ${displayValue}</div>
            </div>
          </div>
        </div>
      `;
    }

    const spendParam = params.find((param: any) => param.seriesName === "Marketing Spend");
    const revenueParam = params.find((param: any) => param.seriesName === "Marketing Revenue");

    if (!spendParam && !revenueParam) {
      return "";
    }

    const label = spendParam ? spendParam.name : revenueParam?.name;

    const metricFormatter = (value: number) =>
      selectedView === MetricView.SpendVsRevenueDollars
        ? formatCurrency(value, ABBREVIATED_OPTION)
        : `${round(value * 100, 2)}%`;

    return `
        <div style='padding: 16px; border-radius: 4px;'>
          <div style='display: flex; flex-direction: column; gap: 0.5rem;'>
            <div style='font-weight: 600; margin-bottom: 0.5rem;'>${label}</div>
            ${
              spendParam
                ? `<div style='display: flex; align-items: center; gap: 0.5rem;'>
              <div style='width: 12px; height: 12px; background-color: ${spendParam.color}; border-radius: 2px;'></div>
              <div>${spendParam.seriesName}: ${metricFormatter(spendParam.value)}</div>
            </div>`
                : ""
            }
            ${
              revenueParam
                ? `<div style='display: flex; align-items: center; gap: 0.5rem;'>
              <div style='width: 12px; height: 12px; background-color: ${revenueParam.color}; border-radius: 2px;'></div>
              <div>${revenueParam.seriesName}: ${metricFormatter(revenueParam.value)}</div>
            </div>`
                : ""
            }
          </div>
        </div>
      `;
  },
});
